<div class="view-container">
  <div class="renderers">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Rendered Output</label>
        </div>

        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content>
            <!-- Filter Section -->
            <div class="filter-section" fxLayout="column" fxLayoutGap="15px">
              
              <!-- Search and Main Controls -->
              <div class="filter" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="stretch">
                <mat-form-field class="accent" fxFlex fxFlex.lt-md="100">
                  <mat-label>Search rendered outputs</mat-label>
                  <input matInput type="text" [(ngModel)]="searchTerm" (keyup.enter)="onSearchChange()"
                    (keyup.esc)="searchTerm=''; onSearchChange()" name="searchTerm" placeholder="Search Name">
                  <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearSearchFilter()">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
                
                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center" fxFlex="none" fxLayout.lt-md="row" fxLayoutAlign.lt-md="center center">
                  <button mat-icon-button matTooltip="Live only!" [color]="isProductionOnly ? 'accent' : 'basic'" (click)="toggleIsProductionOnly()">
                    <mat-icon>verified</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="My outputs only!" [color]="myOutputsFilter ? 'accent' : 'basic'" (click)="toggleMyOutputs()">
                    <mat-icon>person</mat-icon>
                  </button>
                  <button type="submit" mat-flat-button color="primary" (click)="loadRenderedOutputs()" matTooltip="Refresh"
                    [class.button-spinner]="loading" [disabled]="loading">
                    <mat-icon>refresh</mat-icon> Refresh
                  </button>
                </div>
              </div>
              
              <!-- Advanced Filters -->
              <div class="advanced-filters" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
                
                <!-- Product Type Filter -->
                <mat-form-field class="filter-field" fxFlex="33.33" fxFlex.lt-md="100">
                  <mat-label>Product Type</mat-label>
                  <mat-select [(ngModel)]="productTypeFilter" (ngModelChange)="onProductTypeFilterChange($event)">
                    <mat-option [value]="undefined">All Products</mat-option>
                    <mat-option *ngFor="let option of productTypeOptions" [value]="option.value">
                      {{option.label}}
                    </mat-option>
                  </mat-select>
                  <button mat-icon-button matSuffix *ngIf="productTypeFilter" (click)="clearProductTypeFilter()" aria-label="Clear">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
                
                <!-- Status Filter -->
                <mat-form-field class="filter-field" fxFlex="33.33" fxFlex.lt-md="100">
                  <mat-label>Status</mat-label>
                  <mat-select [(ngModel)]="statusFilter" (ngModelChange)="onStatusFilterChange($event)">
                    <mat-option [value]="undefined">All Statuses</mat-option>
                    <mat-option *ngFor="let option of statusOptions" [value]="option.value">
                      {{option.label}}
                    </mat-option>
                  </mat-select>
                  <button mat-icon-button matSuffix *ngIf="statusFilter !== undefined" (click)="clearStatusFilter()" aria-label="Clear">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
                
                <!-- Created By Filter -->
                <mat-form-field class="filter-field" fxFlex="33.33" fxFlex.lt-md="100">
                  <mat-label>Created By</mat-label>
                  <input matInput [(ngModel)]="createdByFilter" (ngModelChange)="onCreatedByFilterChange($event)" placeholder="User name">
                  <button mat-icon-button matSuffix *ngIf="createdByFilter" (click)="clearCreatedByFilter()" aria-label="Clear">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
                
              </div>
              
              <!-- Filter Pills/Chips -->
              <div class="filter-pills" fxLayout="column" fxLayoutGap="10px" *ngIf="totalActiveFilters > 0 || isProductionOnly || myOutputsFilter">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="start start">
                  <small class="text-info"><i>active filters:</i></small>
                  <small *ngIf="totalActiveFilters === 0 && !isProductionOnly && !myOutputsFilter" class="text-warning">
                    no filters currently applied
                  </small>
                  <mat-chip-list>
                    <!-- Toggle Filter Pills (permanent, toggleable) -->
                    <mat-chip 
                      [color]="isProductionOnly ? 'primary' : 'default'"
                      [selectable]="true"
                      (click)="toggleIsProductionOnly()">
                      <mat-icon>{{isProductionOnly ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
                      Production Only
                    </mat-chip>
                    <mat-chip 
                      [color]="myOutputsFilter ? 'primary' : 'default'"
                      [selectable]="true"
                      (click)="toggleMyOutputs()">
                      <mat-icon>{{myOutputsFilter ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
                      My Outputs
                    </mat-chip>
                    
                    <!-- Dynamic Filter Chips (removable when active) -->
                    <mat-chip *ngIf="productTypeFilter !== undefined" color="accent">
                      <span>Product: {{ getProductTypeName(productTypeFilter) }}</span>
                      <button matChipRemove>
                        <mat-icon color="primary" matTooltip="Clear product type filter" (click)="clearProductTypeFilter()">clear</mat-icon>
                      </button>
                    </mat-chip>
                    <mat-chip *ngIf="statusFilter !== undefined" color="accent">
                      <span>Status: {{ getStatusName(statusFilter) }}</span>
                      <button matChipRemove>
                        <mat-icon color="primary" matTooltip="Clear status filter" (click)="clearStatusFilter()">clear</mat-icon>
                      </button>
                    </mat-chip>
                    <mat-chip *ngIf="createdByFilter" color="accent">
                      <span>Created By: {{ createdByFilter }}</span>
                      <button matChipRemove>
                        <mat-icon color="primary" matTooltip="Clear created by filter" (click)="clearCreatedByFilter()">clear</mat-icon>
                      </button>
                    </mat-chip>
                    <mat-chip *ngIf="searchTerm" color="accent">
                      <span>Search: "{{ searchTerm }}"</span>
                      <button matChipRemove>
                        <mat-icon color="primary" matTooltip="Clear search filter" (click)="clearSearchFilter()">clear</mat-icon>
                      </button>
                    </mat-chip>
                  </mat-chip-list>
                </div>
              </div>
              
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="contrast" *ngFor="let item of dataSource.data" [class.banner-error]="item?.disabled" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="85" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="2px">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                <strong class="text-center" [matTooltip]="item?.id" [ngClass.lt-sm]="{'card-title': true}" [ngStyle]="{ 'color': getProductColour(item?.productName) }">
                  {{ productName[item?.productName] }} 
                </strong>
                <mat-icon *ngIf="item?.isProduction" color="accent">verified</mat-icon>
              </div>
              <div fxLayout="row" fxLayoutAlign="end center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center" fxLayoutGap="2px">
                <div class="m-l-10" *ngIf="item?.homeConfig?.home" fxLayoutGap="5px">
                  <span class="text-small">home</span>
                  <span class="text-small" [ngStyle]="{ 'color': getProductColour(item?.productName) }" [matTooltip]="'home: ' + item.homeConfig.home" [innerHtml]="item.homeConfig.home | encodeHtml | highlight: searchTerm"></span>
                </div>
                <div *ngIf="item?.homeConfig?.masterFile" fxLayoutGap="5px">
                  <span class="text-small">master</span>
                  <span class="text-small" [ngStyle]="{ 'color': getProductColour(item?.productName) }" [matTooltip]="'masterFile: ' + item.homeConfig.masterFile" [innerHtml]="item.homeConfig.masterFile | encodeHtml | highlight: searchTerm"></span>
                </div>
                <div *ngIf="item?.homeConfig?.options?.length > 0" fxLayoutGap="5px">
                  <span class="text-small">options</span>
                  <span class="text-small" [ngStyle]="{ 'color': getProductColour(item?.productName) }" [matTooltip]="'options: ' + (item.homeConfig.options.join(', '))" [innerHtml]="item.homeConfig.options.join(', ') | encodeHtml | highlight: searchTerm"></span>
                </div>
                <div *ngIf="item?.styleConfigTemplate?.name" fxLayoutGap="5px">
                  <span class="text-small">template</span>
                  <span class="text-small" [ngStyle]="{ 'color': getProductColour(item?.productName) }" [matTooltip]="'style template: ' + item?.styleConfigTemplate?.name" [innerHtml]="item.styleConfigTemplate.name | encodeHtml | highlight: searchTerm"></span>
                </div>
                <div><small>created <span [matTooltip]="item?.createdByName" class="text-success">by </span><span class="text-info" matTooltip="{{ item?.dateCreated | date:'long' }}">{{ item?.dateCreated | date }}</span></small></div>
              </div>
            </div>
            <div fxFlex="15" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="5px">
              <mat-icon [class]="getStatusIconAndClass(item.status).class"
                [matTooltip]="getStatusIconAndClass(item.status).description"
                (click)="viewRecipeEventSummaryDetail(item?.artifactId)">
                {{ getStatusIconAndClass(item.status).icon }}
              </mat-icon>

              <a *ngIf="(item.productName === productName.Panorama || item.productName === productName.RayTracedDraft || item.productName === productName.RayTraced || item.productName === productName.RayTracedPlus)"
                [disabled]="item.status !== status.Complete"
                matSuffix mat-icon-button color="accent" matTooltip="View"
                target="_blank" [routerLink]="['/situ-view']" [queryParams]="{ id: item.id }">
                <mat-icon>vrpano</mat-icon>
              </a>

              <a *ngIf="(item.productName === productName.Insights)"
                [disabled]="item.status !== status.Complete"
                matSuffix mat-icon-button color="accent" matTooltip="View Insights"
                target="_blank" [routerLink]="['/situ-view']" [queryParams]="{ id: item.id }">
                <mat-icon>insights</mat-icon>
              </a>

              <a *ngIf="(item.productName === productName.Plan)"
                [disabled]="item.status !== status.Complete"
                matSuffix mat-icon-button color="accent" matTooltip="View Plan"
                target="_blank" [routerLink]="['/situ-view']" [queryParams]="{ id: item.id }">
                <mat-icon>schema</mat-icon>
              </a>

              <a *ngIf="(item.productName === productName.Facade)"
                [disabled]="item.status !== status.Complete"
                matSuffix mat-icon-button color="accent" matTooltip="View Facade"
                target="_blank" [routerLink]="['/situ-facade']" [queryParams]="{ id: item.id }">
                <mat-icon>image</mat-icon>
              </a>

              <source-artifacts-menu [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode" [sourceArtifacts]="item.sourceArtifacts"></source-artifacts-menu>

              <a *ngIf="isSituUser && canScanForProductUsage(item)"
                matSuffix mat-icon-button color="accent"
                [matTooltip]="scanningArtifactId === item.artifactId ? 'Scanning…' : 'Scan for product usage'"
                [disabled]="!!scanningArtifactId"
                (click)="scanForProductUsage(item)">
                <mat-icon *ngIf="scanningArtifactId !== item.artifactId">fingerprint</mat-icon>
                <mat-spinner *ngIf="scanningArtifactId === item.artifactId" diameter="20"></mat-spinner>
              </a>

              <a [disabled]="item.status === status.Cancelled"
                matSuffix mat-icon-button color="primary" matTooltip="Cancel"
                target="_blank" (click)="cancelRenderedOutput(item)">
                <mat-icon>cancel</mat-icon>
              </a>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
            [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
            (page)="onPageChange($event)">
          </mat-paginator>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
</div>